const LOG_PREFIX = "[OCM][Custom] "

let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    resolve(true)
  });
}
module.exports = customCode;